<template>
    <div class="animated fadeIn">
     
      <b-row>
        <b-col sm="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
            <strong> Handover Pendency </strong> 
            </div>
            <b-row>
             <b-col md="12" >
      
             <div>
              <ul class="nav nav-tabs nav-justified">
                <li class="nav-item">
                  <a @click="activeTab = 0"  class="nav-link " :class="{'active' : isActiveTab(0)}">WH Handover Report</a>
                </li>
  
                <li class="nav-item">
                  <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >WH Handover Pendency Report</a>
                </li>
               
              </ul>
            </div>
             
            </b-col>
            <b-col md="12" >
          
              <div class="tab-panel" v-if="isActiveTab(0)">
                <WH_HandoverReport></WH_HandoverReport>
              </div>
  
              <div class="tab-panel" v-if="isActiveTab(1)">
              <WH_HandoverPendencyReport></WH_HandoverPendencyReport>
              </div>
               </b-col>
            </b-row> 
          </b-card>
         
        </b-col>
      </b-row> 
    </div>   
    
  </template>
  <script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import WH_HandoverReport from "./WH_HandoverReport.vue";
  import WH_HandoverPendencyReport from "./WH_HandoverPendencyReport.vue";
  // import PickCancel_mr from './pickCancel_mr.vue'
  
  export default {
    data: function() {
      return {
        activeTab: 0,
        WH_HandoverReport,
        WH_HandoverPendencyReport,
      };
    },
    components: {
      WH_HandoverReport,
      WH_HandoverPendencyReport,
    },
    created: function() {
      this.isActiveTab(0);
    },

    methods: {
        isActiveTab(id)
      {
         return this.activeTab === id
      }
    }
  };
  </script>
  